// Per-section accent colors — Ocean Blue + White theme.
// Each section uses ocean / sky / cyan / teal variations to feel cohesive while staying distinct.
// (light theme values; CSS variables in index.css adapt them for dark theme.)
export const SECTION_ACCENTS = {
  dashboard:    { a: "#0369A1", b: "#0EA5E9" }, // ocean → sky
  diagnostics:  { a: "#B91C1C", b: "#F97316" }, // crimson → orange (health check)
  tracker:      { a: "#0EA5E9", b: "#06B6D4" }, // sky → cyan
  requirements: { a: "#0C4A6E", b: "#0369A1" }, // deep ocean → ocean
  gap:          { a: "#0EA5E9", b: "#14B8A6" }, // sky → teal
  raid:         { a: "#0C4A6E", b: "#075985" }, // deep blues for risk gravity
  actions:      { a: "#0369A1", b: "#06B6D4" }, // ocean → cyan
  budget:       { a: "#0EA5E9", b: "#38BDF8" }, // sky → bright sky
  stakeholders: { a: "#075985", b: "#22D3EE" }, // deep ocean → bright cyan
  s4hana:       { a: "#0C4A6E", b: "#14B8A6" }, // deep ocean → teal (executive)
  strategy:     { a: "#0C4A6E", b: "#0EA5E9" }, // deep ocean → sky
  governance:   { a: "#111827", b: "#4B5563" }, // slate → charcoal (executive)
  fitToStandard:{ a: "#1E293B", b: "#0EA5E9" }, // navy → sky
  dataMigration:{ a: "#0F766E", b: "#2DD4BF" }, // teal → aqua
  integration:  { a: "#312E81", b: "#818CF8" }, // indigo → violet
  testing:      { a: "#7C2D12", b: "#F97316" }, // burnt umber → orange
  ocm:          { a: "#831843", b: "#F472B6" }, // deep rose → pink
  cutover:      { a: "#7F1D1D", b: "#F59E0B" }, // maroon → amber
  valueRealization:{ a: "#14532D", b: "#22C55E" }, // forest → green
  ipLibrary:    { a: "#0F172A", b: "#94A3B8" }, // ink → mist
  integrations: { a: "#0369A1", b: "#06B6D4" }, // ocean → cyan
  ai:           { a: "#5B21B6", b: "#A855F7" }, // deep violet → violet
  documents:    { a: "#0F172A", b: "#0EA5E9" }, // ink → sky (Activate pipeline)
};

export function accentVars(id) {
  const a = SECTION_ACCENTS[id] || SECTION_ACCENTS.dashboard;
  return { "--accent": a.a, "--accent-a": a.a, "--accent-b": a.b };
}

// Health stripes keep semantic colors so health stays instantly readable.
export const HEALTH_COLORS = {
  "On Track":  "#16A34A",
  "At Risk":   "#D97706",
  "Off Track": "#DC2626",
  "On Hold":   "#71717A",
  "Escalated": "#DC2626",
};
